const profile =
  "https://i.pinimg.com/564x/94/46/1c/94461c92f56fdd4fbd34d6c74e8cf467.jpg";

export { profile };
